import React, { useState, useEffect, useCallback } from 'react';
import { Chats } from './chats';
import { ChatroomView } from './Chatroom';
import { getAdminChatrooms, getPendingAdminChatrooms, assignFadfaddahRoom, ChatroomData } from './utilities';
import { useFadfaddahSocket } from './useFadfaddahSocket';
import './Fadfaddah.css';

function getUserId(): string | null {
  return localStorage.getItem('id')
    || localStorage.getItem('userId')
    || localStorage.getItem('userID');
}

export default function FadfaddahPage() {
  const [recentChatrooms, setRecentChatrooms] = useState<ChatroomData[]>([]);
  const [pendingChatrooms, setPendingChatrooms] = useState<ChatroomData[]>([]);
  const [selected, setSelected] = useState<ChatroomData | null>(null);
  const [loading, setLoading] = useState(true);

  const fetchAll = useCallback(async () => {
    const userId = getUserId();
    if (!userId) return;
    try {
      const [recent, pending] = await Promise.all([
        getAdminChatrooms(userId),
        getPendingAdminChatrooms(userId),
      ]);
      setRecentChatrooms(recent);
      setPendingChatrooms(pending);
    } catch (err) {
      console.error('Failed to fetch chatrooms', err);
    } finally {
      setLoading(false);
    }
  }, []);

  // Refresh both lists when any new_message comes in
  useFadfaddahSocket(getUserId(), selected?.id || null, fetchAll, fetchAll);

  useEffect(() => {
    fetchAll();
  }, [fetchAll]);

  const handleSelect = async (room: ChatroomData) => {
    // If it's a pending room, assign it first
    if (!room.adminId) {
      try {
        const updated = await assignFadfaddahRoom(room.id);
        // Remove from pending, add to recent, and select
        setPendingChatrooms((prev) => prev.filter((r) => r.id !== room.id));
        const assignedRoom = { ...room, adminId: updated.adminId };
        setRecentChatrooms((prev) => [assignedRoom, ...prev]);
        setSelected(assignedRoom);
        return;
      } catch (err) {
        console.error('Failed to assign fadfaddah room', err);
        return;
      }
    }
    setSelected(room);
  };

  return (
    <div className="fadfaddah-page">
      <div className="fadfaddah-container">
        <div className="fadfaddah-sidebar">
          <div className="fadfaddah-sidebar-title">Fadfaddah Chats</div>
          {loading ? (
            <div className="fadfaddah-chats-loading">Loading chats…</div>
          ) : (
            <Chats
              recentChatrooms={recentChatrooms}
              pendingChatrooms={pendingChatrooms}
              selectedId={selected?.id || null}
              onSelect={handleSelect}
            />
          )}
        </div>
        <div className="fadfaddah-main">
          {selected ? (
            <ChatroomView chatroom={selected} />
          ) : (
            <div className="fadfaddah-main-empty">
              <div className="fadfaddah-main-empty-icon">💬</div>
              <h3>Select a conversation</h3>
              <p>Choose a chat from the sidebar to start messaging</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
